<template>
  <v-container
    v-if="this.$store.getters['hasPermission'](permission)"
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout wrap>
      <v-flex
        v-if="this.$store.getters['hasPermission'](projectPermission)"
        md12
        lg12
      >
        <user-project />
      </v-flex>
      <v-flex
        md12
        sm12
        lg6
      >
        <material-chart-card
          :data="dailySalesChart.data"
          :options="dailySalesChart.options"
          color="info"
          type="Line"
        >
          <h4 class="title font-weight-light">Total Daily Visit Sales</h4>
          <p class="category d-inline-flex font-weight-light">Visit Performance of 1 week span</p>
          <!--          <p class="category d-inline-flex font-weight-light">-->
          <!--            <v-icon-->
          <!--              color="green"-->
          <!--              small-->
          <!--            >-->
          <!--              mdi-arrow-up-->
          <!--            </v-icon>-->
          <!--            <span class="green&#45;&#45;text">55%</span>&nbsp;-->
          <!--            increase in today's visits-->
          <!--          </p>-->

          <template slot="actions">
            <v-icon
              class="mr-2"
              small
            >
              mdi-calendar-range
            </v-icon>
            <span class="caption grey-lighten-1--text font-weight-light">1 Week Span</span>
          </template>
        </material-chart-card>
      </v-flex>
      <v-flex
        md12
        sm12
        lg6
      >
        <material-chart-card
          :data="ytdPoAmountChart.data"
          :options="ytdPoAmountChart.options"
          :responsive-options="ytdPoAmountChart.responsiveOptions"
          color="success"
          type="Bar"
        >
          <h4 class="title font-weight-light">Total Purchase Order Amount {{ new Date().getFullYear() }} (in Million
          IDR)</h4>
          <p class="category d-inline-flex font-weight-light">Year To Date PO Exact Amount = {{ toPriceFormat(ytdPoAmountChart.customTotalYearPoAmount) }} IDR</p>

          <template slot="actions">
            <v-icon
              class="mr-2"
              small
            >
              mdi-calendar-range
            </v-icon>
            <span class="caption blue-grey--text font-weight-light">1 Year span</span>
          </template>
        </material-chart-card>
      </v-flex>
      <!--      <v-flex-->
      <!--        md12-->
      <!--        sm12-->
      <!--        lg4-->
      <!--      >-->
      <!--        <material-chart-card-->
      <!--          :data="dataCompletedTasksChart.data"-->
      <!--          :options="dataCompletedTasksChart.options"-->
      <!--          color="indigo"-->
      <!--          type="Line"-->
      <!--        >-->
      <!--          <h3 class="title font-weight-light">Completed Tasks</h3>-->
      <!--          <p class="category d-inline-flex font-weight-light">Last Last Campaign Performance</p>-->

      <!--          <template slot="actions">-->
      <!--            <v-icon-->
      <!--              class="mr-2"-->
      <!--              small-->
      <!--            >-->
      <!--              mdi-clock-outline-->
      <!--            </v-icon>-->
      <!--            <span class="caption grey&#45;&#45;text font-weight-light">campaign sent 26 minutes ago</span>-->
      <!--          </template>-->
      <!--        </material-chart-card>-->
      <!--      </v-flex>-->
      <v-flex
        sm6
        xs12
        md6
        lg3
      >
        <v-menu
          ref="menuPo"
          v-model="menuPo"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="computedMonthYearValuePo"
              label="Month Year Selection"
              prepend-icon="event"
              readonly
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="monthYearSelectPo"
            type="month"
            scrollable
            @input="menuPo = false"
          />
        </v-menu>
        <material-stats-card
          :value="toPriceFormat(dashbboardCardStatus.totalPoValue)"
          :sub-text="'On '+ getYearMonthName(monthYearSelectPo) + ' in Thousand'"
          color="general"
          icon="mdi-cart-plus"
          title="PO Value"
          small-value="K"
          sub-icon="mdi-calendar-text"
          sub-text-color="text-general"
          sub-icon-color="general"
        />
      </v-flex>
      <v-flex
        sm6
        xs12
        md6
        lg3
      >
        <v-menu
          ref="menuQuo"
          v-model="menuQuo"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="computedMonthYearValueQuo"
              label="Month Year Selection"
              prepend-icon="event"
              readonly
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="monthYearSelectQuo"
            type="month"
            scrollable
            @input="menuQuo = false"
          />
        </v-menu>
        <material-stats-card
          :value="toPriceFormat(dashbboardCardStatus.totalQuotationValue)"
          :sub-text="'On '+ getYearMonthName(monthYearSelectQuo)+' in Thousand'"
          color="green"
          icon="mdi-sale"
          title="Quotation"
          small-value="K"
          sub-icon="mdi-calendar-text"
          sub-text-color="text-general"
          sub-icon-color="general"/>
      </v-flex>
      <v-flex
        sm6
        xs12
        md6
        lg3
      >
        <v-text-field
          label="dummy placeholder"
          style="visibility: hidden"
          readonly
        />
        <material-stats-card
          :value="dashbboardCardStatus.totalProjectOn"
          color="info"
          icon="mdi-calendar-clock"
          title="On Progress"
          sub-icon="mdi-calendar-range"
          sub-text="Total On Going Projects"
          sub-text-color="text-general"
          sub-icon-color="general"
        />
      </v-flex>
      <v-flex
        sm6
        xs12
        md6
        lg3
      >
        <v-text-field
          label="dummy placeholder"
          style="visibility: hidden"
          readonly
        />
        <material-stats-card
          :value="dashbboardCardStatus.totalProjectDelay"
          :sub-text="dashbboardCardStatus.totalProjectDelay > 0 ? 'Past due date, please check ...' : 'No delay project, Good Work!'"
          :color="dashbboardCardStatus.totalProjectDelay > 0 ? 'error' : 'warning'"
          :sub-icon="dashbboardCardStatus.totalProjectDelay > 0 ? 'mdi-alert': 'mdi-information'"
          :sub-icon-color="dashbboardCardStatus.totalProjectDelay > 0 ? 'error' : 'success'"
          :sub-text-color="dashbboardCardStatus.totalProjectDelay > 0 ? 'text-danger' : 'text-success'"
          icon="mdi-calendar-clock"
          title="Delayed"
        />
      </v-flex>
      <v-flex
        md12
        lg6
      >
        <material-card
          color="general"
          title="Progress of Projects"
          text="Top 5 Project By Nearest Due Date"
        >
          <v-data-table
            :headers="progressProjectHeaders"
            :items="dashboardTable.progressProject"
            hide-actions
          >
            <template
              slot="items"
              slot-scope="{ index, item }"
            >
              <td>{{ item.refNo }}</td>
              <td>{{ item.customer.company.name }}</td>
              <td>{{ item.dueDate }}</td>
              <td>{{ item.percentage }}%</td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
      <v-flex
        md12
        lg6
      >
        <material-card
          color="general"
          title="Visit of Projects"
          text="Top 5 Visit By Nearest Due Date"
        >
          <v-data-table
            :headers="visitOfProjectsHeaders"
            :items="dashboardTable.visitOfProjects"
            hide-actions
          >
            <template
              slot="items"
              slot-scope="{ index, item }"
            >
              <td>{{ item.refNo }}</td>
              <td>{{ item.customer.company.name }}</td>
              <td>{{ item.quota }}</td>
              <td>{{ item.totalVisitDistinct }}</td>
              <td>{{ item.quota - item.totalVisitDistinct }}</td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
      <v-flex
        md12
        lg6
      >
        <material-card
          color="general"
          title="Sales Visit on This Month"
          text="Top Sales Visit By Day & Company"
        >
          <v-data-table
            :headers="userSalesVisitAchievementHeaders"
            :items="dashboardTable.salesVisitAchievement"
            hide-actions
          >
            <template
              slot="items"
              slot-scope="{ index, item }"
            >
              <td>{{ item.salesUsername }} ({{ item.salesName }})</td>
              <td>{{ item.targetVisit }}</td>
              <td>{{ item.actualVisit }}</td>
              <td>{{ item.pctg }}%</td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
      <v-flex
        md12
        lg6
      >
        <material-card
          color="general"
          title="Sales Achievement on This Month"
          text="Top OIS Sales By Revenue (PO Amount)"
        >
          <v-data-table
            :headers="userSalesAchievementHeaders"
            :items="dashboardTable.salesAmountPoAchievement"
            hide-actions
          >
            <template
              slot="items"
              slot-scope="{ index, item }"
            >
              <td>{{ item.salesUsername }} ({{ item.salesName }})</td>
              <td>{{ toPriceFormat(item.target) }}</td>
              <td>{{ toPriceFormat(item.actual) }}</td>
              <td>{{ item.pctg }}%</td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
      <v-flex
        md12
        lg6
      >
        <material-card
          color="general"
          title="User Follow up on This Month"
          text="Top User Follow up By Day"
        >
          <!--          <v-menu-->
          <!--            ref="menuFu"-->
          <!--            v-model="menuFu"-->
          <!--            :close-on-content-click="false"-->
          <!--            :nudge-right="40"-->
          <!--            lazy-->
          <!--            transition="scale-transition"-->
          <!--            offset-y-->
          <!--            full-width-->
          <!--            max-width="290px"-->
          <!--            min-width="290px"-->
          <!--          >-->
          <!--            <template v-slot:activator="{ on }">-->
          <!--              <v-text-field-->
          <!--                :value="computedMonthYearValueFu"-->
          <!--                label="Month Year Selection"-->
          <!--                prepend-icon="event"-->
          <!--                readonly-->
          <!--                v-on="on"-->
          <!--              />-->
          <!--            </template>-->
          <!--            <v-date-picker-->
          <!--              v-model="monthYearSelectFu"-->
          <!--              type="month"-->
          <!--              no-title-->
          <!--              scrollable-->
          <!--              @input="menuFu = false"-->
          <!--            />-->
          <!--          </v-menu>-->
          <v-data-table
            :headers="userSalesFollowupAchievementHeaders"
            :items="dashboardTable.salesFollowupAchievement"
            hide-actions
          >
            <template
              slot="items"
              slot-scope="{ index, item }"
            >
              <td>{{ item.salesUsername }} ({{ item.salesName }})</td>
              <td>{{ item.targetFu }}</td>
              <td>{{ item.actualFu }}</td>
              <td>{{ item.pctg }}%</td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import displayFormatterMixins from '../../mixins/displayFormatterMixins'
  import UserProject from './project/UserProject'

  export default {
  name: 'Dashboard',
  components: { UserProject },
  mixins: [displayFormatterMixins],
  data () {
    return {
      // dataCompletedTasksChart: {
      //   data: {
      //     labels: ['12am', '3pm', '6pm', '9pm', '12pm', '3am', '6am', '9am'],
      //     series: [
      //       [230, 750, 450, 300, 280, 240, 200, 190]
      //     ]
      //   },
      //   options: {
      //     lineSmooth: this.$chartist.Interpolation.cardinal({
      //       tension: 0
      //     }),
      //     low: 0,
      //     high: 1000,
      //     chartPadding: {
      //       top: 0,
      //       right: 0,
      //       bottom: 0,
      //       left: 0
      //     }
      //   }
      // },
      menuPo: false,
      menuFu: false,
      menuQuo: false,
      // monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      monthYearSelectPo: '',
      monthYearSelectQuo: '',
      monthYearSelectFu: '',
      permission: 'MA_DASHBOARD',
      projectPermission: 'MA_PROJECT',
      dashbboardCardStatus: {
        totalPoValue: 0,
        totalQuotationValue: 0,
        totalProjectOn: 0,
        totalProjectDelay: 0
      },
      dashboardTable: {
        progressProject: [],
        visitOfProjects: [],
        salesVisitAchievement: [],
        salesAmountAchievement: [], // Old
        salesAmountPoAchievement: [], // New
        salesFollowupAchievement: []
      },
      dailySalesChart: {
        data: {
          labels: [], // ['Sun', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'], // default
          series: [
           // [4, 1, 7, 0, 9, 17, 8] // Testing
          ]
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0
          }),
          low: 0,
          high: 32, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 20,
            right: 0,
            bottom: 0,
            left: 0
          }
          // axisY: {
          //   type: this.$chartist.FixedScaleAxis,
          //   ticks: [0, 4, 8, 12, 16, 20, 24, 28, 32],
          //   low: 0
          // } // got infinite loop error
        }
      },

      ytdPoAmountChart: {
        data: {
          labels: [], // ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'], // default
          series: [
            // [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895],
            // [255, 333, 666, 222, 111, 999, 333, 666, 777, 888, 432, 754] // maybe 2020-2021
          ]
        },
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          high: 10000, // ~ multiply of 1 Mil = 10 000 000 000 Bil
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 5
          }
        },
        responsiveOptions: [
          ['screen and (max-width: 768x)', {
            seriesBarDistance: 5,
            axisX: {
              labelInterpolationFnc: function (value) {
                return value[0]
              }
            }
          }]
        ],
        customTotalYearPoAmount: 0
      },
      progressProjectHeaders: [
        { sortable: false, text: 'Project Ref.', value: 'refNo' },
        { sortable: false, text: 'Company', value: 'customer.company.name' },
        { sortable: false, text: 'Due Date', value: 'dueDate' },
        { sortable: false, text: 'Progress', value: '' }
      ],
      userSalesAchievementHeaders: [
        { sortable: false, text: 'Sales Username', value: 'username' },
        { sortable: false, text: 'Target (IDR)', value: 'target' },
        { sortable: false, text: 'Actual (IDR)', value: 'actual' },
        { sortable: false, text: 'Achievement', value: 'pctg' }
      ],
      visitOfProjectsHeaders: [
        { sortable: false, text: 'Project Ref.', value: 'refNo' },
        { sortable: false, text: 'Company', value: 'customer.company.name' },
        { sortable: false, text: 'Quota', value: 'quota' },
        { sortable: false, text: 'Actual', value: 'totalVisitDistinct' },
        { sortable: false, text: 'Deviasi', value: '' }
      ],
      userSalesVisitAchievementHeaders: [
        { sortable: false, text: 'Sales Username', value: 'username' },
        { sortable: false, text: 'Target', value: 'target' },
        { sortable: false, text: 'Actual', value: 'actual' },
        { sortable: false, text: 'Achievement', value: 'pctg' }
      ],
      userSalesFollowupAchievementHeaders: [
        { sortable: false, text: 'Sales Username', value: 'username' },
        { sortable: false, text: 'Target Fu', value: 'target' },
        { sortable: false, text: 'Actual Fu', value: 'actual' },
        { sortable: false, text: 'Achievement', value: 'pctg' }
      ]
    }
  },
  computed: {
    ...mapGetters(['hasPermission']),
    // computedMonthYearValueFu () {
    //   const [year, month] = this.monthYearSelectFu.split('-')
    //   const monthName = this.monthNames[parseInt(month) - 1]
    //   return `${monthName} ${year} `
    // },
    computedMonthYearValueQuo () {
      const [year, month] = this.monthYearSelectQuo.split('-')
      const monthName = this.$data.monthNames[parseInt(month) - 1]
      return `${monthName} ${year} `
    },
    computedMonthYearValuePo () {
      const [year, month] = this.monthYearSelectPo.split('-')
      const monthName = this.$data.monthNames[parseInt(month) - 1]
      return `${monthName} ${year} `
    }
  },
  watch: {
    async monthYearSelectPo () {
      let response = await this.$http.get(`/api/dashboard/statusCard/totalPo?yearmonth=${this.monthYearSelectPo}`)
      this.dashbboardCardStatus.totalPoValue = response.data.totalPoValue / 1000
    },
    async monthYearSelectQuo () {
      let response = await this.$http.get(`/api/dashboard/statusCard/totalQuo?yearmonth=${this.monthYearSelectQuo}`)
      this.dashbboardCardStatus.totalQuotationValue = response.data.totalQuotationValue / 1000
    }
  },
  created () {
    this.getStatusCards()
    this.getProgressProject()
    this.getChart()
    this.setMonthYearSelectInit()
  },
  methods: {
    setMonthYearSelectInit () {
      const [day, month, year] = new Date().toLocaleDateString('en-gb').split('/')
      this.monthYearSelectPo = `${year}-${month}`
      // this.monthYearSelectFu = `${year}-${month}`
      this.monthYearSelectQuo = `${year}-${month}`
    },
    complete (index) {
      this.list[index] = !this.list[index]
    },
    async getStatusCards () {
      let response = await this.$http.get('/api/dashboard/statusCard')
      this.dashbboardCardStatus = response.data
      this.dashbboardCardStatus.totalPoValue = this.dashbboardCardStatus.totalPoValue / 1000
      this.dashbboardCardStatus.totalQuotationValue = this.dashbboardCardStatus.totalQuotationValue / 1000
    },
    async getProgressProject () {
      let response = await this.$http.get('/api/dashboard/tables')
      this.dashboardTable = response.data
    },
    async getChart () {
      let response = await this.$http.get('/api/dashboard/chart')
      let arr = response.data.monthYearPoAmounts
      let denom = 1000000 // 1 Mil
      for (let i = 0; i < arr.length; i++) {
        arr[i] = arr[i] / denom
      }
      this.ytdPoAmountChart.customTotalYearPoAmount = response.data.totalYearPoAmount
      this.ytdPoAmountChart.data.labels = response.data.labelYears
      this.ytdPoAmountChart.data.series.push(arr)
      this.ytdPoAmountChart.options.high = (response.data.highestAmount / denom) * 1.5
      this.dailySalesChart.data.labels = response.data.labelWeekDays
      this.dailySalesChart.data.series.push(response.data.dailyVisitPerWeek)
      this.dailySalesChart.options.high = Math.ceil(response.data.highestVisit * 1.5)
    }
  }

}
</script>
